import { Card, Typography } from 'antd';
import FormItem from 'antd/es/form/FormItem';
import { ControlledInputNumber } from 'modules/common/components';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { DonorSettingsSchemaType } from '../schema';
import styles from '../styles.module.scss';

const { Title, Text } = Typography;

const MicrochipSettingsSection: FC = () => {
  const { t } = useTranslation('settings.DonorSettings.MicrochipSection');

  const {
    control,
    formState: { errors },
  } = useFormContext<DonorSettingsSchemaType>();

  const microchipPriceError = errors?.microchip?.price?.message;

  return (
    <div className={styles.sectionWrapper}>
      <Card>
        <Title level={4}>{t('title')}</Title>
        <Text>{t('description')}</Text>
        <div style={{ marginTop: 16 }}>
          <Text strong style={{ display: 'block', marginBottom: 8 }}>
            {t('price')}
          </Text>
          <FormItem
            validateStatus={microchipPriceError && 'error'}
            extra={microchipPriceError}
          >
            <ControlledInputNumber
              addonBefore={'$'}
              controlled={{ control, name: 'microchip.price' }}
            />
          </FormItem>
        </div>
      </Card>
    </div>
  );
};

export default MicrochipSettingsSection;
